import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import Home from "./Pages/Home.js"
import Members from './Pages/Members.js';
import CallForPaper from './Pages/Call_For_Paper.js';
import Registration_Fees from './Pages/Registration_Fees.js';
import Contact from './Pages/Contact.js';
import Workshop_DigitalPrivacy from "./Pages/Workshop_DigitalPrivacy.js"
import Workshop_Federated from "./Pages/Workshop_Federated.js"
import Previous_Edition_2023 from './Pages/Previous_Edition_2023.js';
import Previous_Edition_2024 from './Pages/Previous_Edition_2024.js';
import KeynoteSpeakers from './Pages/Keynote_Speakers.js';

function App() {
  
  return (
    <>
    <BrowserRouter>
    <Routes>
        <Route path = "/" element = {<Home></Home>}> </Route>
        <Route path = "/members" element = {<Members></Members>}></Route>
        <Route path = "/callforpaper" element = {<CallForPaper></CallForPaper>}></Route>
        <Route path = "/registrationfees" element = {<Registration_Fees></Registration_Fees>}></Route>
        <Route path = "/contact" element = {<Contact></Contact>}></Route>
        <Route path = "/workshopdigitalprivacy" element = {<Workshop_DigitalPrivacy></Workshop_DigitalPrivacy>}></Route>
        <Route path = "/workshopfederated" element = {<Workshop_Federated></Workshop_Federated>}></Route>
        <Route path = "/previousedition2023" element = {<Previous_Edition_2023></Previous_Edition_2023>}></Route>
        <Route path = "/previousedition2024" element = {<Previous_Edition_2024></Previous_Edition_2024>}></Route>
        <Route path = "/keynotespeakers" element = {<KeynoteSpeakers></KeynoteSpeakers>}></Route>
    </Routes>
    </BrowserRouter>
    </>
  
  )
}

export default App;
